import { Component, Inject, OnInit, ViewChild, ElementRef } from '@angular/core';
// import { MAT_DIALOG_DATA, MatDialogRef, MatSnackBar } from '@angular/material';
// import { TranslationService } from '../../../pages/manage-form/form-translate/services/transation.service.service';
import { FormControl, FormGroup } from '@angular/forms';
import { SnackBarComponent } from 'dhwani-material-library';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslationService } from '../../form-translate/services/transation.service.service';
import { TempModuleService } from '../../form-translate/services/temp-module.service';
// import * as QuillNamespace from 'quill';
// const Quill: any = QuillNamespace;
// import { VideoHandler, ImageHandler, Options } from 'ngx-quill-upload';
// Quill.register('modules/imageHandler', ImageHandler);
// Quill.register('modules/videoHandler', VideoHandler);

@Component({
    selector: 'app-consent-translate-dialog',
    templateUrl: './consent-translate-dialog.component.html',
    styleUrls: ['./consent-translate-dialog.component.css'],
    // providers:[TempModuleService]
})
export class ConsentTranslateDialogComponent implements OnInit {

    public consentFormControl: FormControl = new FormControl();
    public newLanguageConsentControl: FormControl = new FormControl();
    public newConsentUrl: FormControl = new FormControl();
    public titleControl: FormControl = new FormControl();
    public urlMap: Map<string, string> = new Map<string, string>();

    @ViewChild('quillFile') quillFileRef: ElementRef;
    quillFile: any;
    meQuillRef: any;
    editorModules = {
        toolbar: {
            container: [
                [{ font: [] }],
                [{ size: ['small', false, 'large', 'huge'] }],
                [{ 'header': [1, 2, 3, 4, 5, 6] }],
                ['bold', 'italic', 'underline', 'strike'],
                ['blockquote', 'code-block'],
                [{ 'script': 'sub' }, { 'script': 'super' }],
                [{ 'indent': '-1' }, { 'indent': '+1' }],
                [{ color: [] }, { background: [] }],
                [{ list: 'ordered' }, { list: 'bullet' }],
                [{ align: [] }],
                ['link', 'image', 'video'],
                ['clean'],
            ],
            handlers: {
                image: (image) => {
                    this.customImageUpload(image);
                },
            }
        },
    };
    selectedUrl: string = ''
    imageUrl: any = "";
    mimeType: string = '';
    isProgress = false;
    constructor(
        public snackBar: MatSnackBar,
        public translationService: TranslationService,
        public surveyBuilderService: TempModuleService,
        public dialogRef: MatDialogRef<ConsentTranslateDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {

    }

    ngOnInit() {
        this.fetchResourceUrlText();
    }

    getMeEditorInstance(editorInstance: any) {
        this.meQuillRef = editorInstance;
        console.log('this.meQuillRef', this.meQuillRef)
    }

    customImageUpload(image: any) {
        console.log(image);
        /* Here we trigger a click action on the file input field, this will open a file chooser on a client computer */
        this.quillFileRef.nativeElement.click();
    }

    quillFileSelected(ev: any) {
        /* After the file is selected from the file chooser, we handle the upload process */
        this.quillFile = ev.target.files[0];
        let image = {
            type: this.quillFile && this.quillFile.type,
            name: this.quillFile && this.quillFile.name,
            file: this.quillFile,
        };
        this.setDocuments(image);
    }

    async setDocuments(imgObject) {
        this.isProgress = true;
        try {
            let response = await this.surveyBuilderService.uploadTos3(
                imgObject.name, imgObject.type
            );
            if (response['success']) {
                this.selectedUrl = response['data'][0]['file_url'];
                try {
                    let imageResponse = await this.surveyBuilderService.getImageUrl(
                        response['data'][0]['url'],
                        imgObject.file
                    );
                    this.selectedUrl = response['data'][0]['file_url'];
                    console.log("ffff", this.selectedUrl, imgObject)
                    const filename = response['data'][0]['url'];
                    let range: any;

                    const img = `<img class="img-within" src=${this.selectedUrl}></img>`;
                    range = this.meQuillRef.getSelection();
                    this.meQuillRef.clipboard.dangerouslyPasteHTML(range.index, img);

                    this.snackBar.dismiss();
                    this.isProgress = false;
                } catch (e) {
                    this.isProgress = false;
                    this.openSnackBar(['Unable to save image'], 3000);
                    console.error(e);
                }
            }
        } catch (e) {
            this.isProgress = false;
            this.openSnackBar(['Unable to save image'], 3000);
        }
    }

    openSnackBar(data: string[], duration) {
        this.snackBar.openFromComponent(SnackBarComponent, { data, duration });
    }

    fetchResourceUrlText() {
        if (this.data.hasOwnProperty('urlEn')) {
            let promiseEn = this.surveyBuilderService.fetchConsentText(this.data.urlEn[0]);
            let promise = this.surveyBuilderService.fetchConsentText(this.data.url[0]);
            promiseEn.then((data: any) => {
                document.getElementById('append-old-consent').innerHTML = data;
                this.consentFormControl.setValue(data);
            }).catch(error => console.log(error));
            promise.then((data: any) => {
                // document.getElementById('append-old-consent').innerHTML = data;
                this.newLanguageConsentControl.setValue(data);
            }).catch(error => console.log(error));

        } else {
            this.urlMap.set(this.data.url[0], null);
            let promise = this.surveyBuilderService.fetchConsentText(this.data.url[0]);
            promise.then((data: any) => {
                document.getElementById('append-old-consent').innerHTML = data;
                this.consentFormControl.setValue(data);
                this.newLanguageConsentControl.setValue(data);
            }).catch(error => console.log(error));
        }

    }

    consentSubmitClickHandler() {
        const editorData = this.meQuillRef && this.meQuillRef.root && this.meQuillRef.root.innerHTML;
        this.newLanguageConsentControl.setValue(editorData);
        var b: any = new Blob([this.newLanguageConsentControl.value], { type: 'text/plain' });
        b.lastModifiedDate = new Date();
        b.name = 'consent.txt';
        this.surveyBuilderService.uploadTos3(b.name, b.type).then((response: any) => {
            if (response.success) {
                this.snackBar.dismiss();
                this.surveyBuilderService.getImageUrl(response['data'][0].url, b).then(data => {
                    this.urlMap.set(this.data.url[0], response['data'][0].file_url);
                    this.dialogRef.close(this.urlMap);
                }).catch(response => console.log(response));
            }
        }).catch((response) => console.log(response));
    }

    copyRawHTML() {
        const editorRawData = this.meQuillRef && this.meQuillRef.root && this.meQuillRef.root.innerHTML;
        const defaultRawData = "<p><br></p>";
        if (editorRawData != defaultRawData) {
            let selBox = document.createElement('textarea');
            selBox.style.position = 'fixed';
            selBox.style.left = '0';
            selBox.style.top = '0';
            selBox.style.opacity = '0';
            selBox.value = editorRawData;
            document.body.appendChild(selBox);
            selBox.focus();
            selBox.select();
            document.execCommand('copy');
            this.openSnackBar(['Data Copied...'], 3000);
            document.body.removeChild(selBox);
        } else {
            this.openSnackBar(['Please enter something'], 3000);
        }
    }

}
